import styled from "@emotion/styled";
import { Flex, mediaQueries, Tabs, Theme } from "@ugc-ui/lego";
import { mixins } from "@src/styles/mixins.styled";

export const CreateCampaignTabs = styled(Tabs)`
  position: relative;
  z-index: 3;

  & > button {
    padding: 0 0 10px 0;
    margin-right: 10px;
    ${mediaQueries.lg} {
      margin-right: 0;
    }
    :hover {
      border-bottom-width: 1px;
    }
  }
  ${mediaQueries.lg} {
    flex: 1;
  }
`;

export const CreateCampaignsInputsContainer = styled(Flex)<{ theme: Theme }>`
  overflow: auto;
  height: 586px;
  padding: 8px 10px 24px 0;
  ${({ theme }) => mixins.scroll(theme)}
  ${mediaQueries.lg} {
    height: auto;
  }
`;

export const CreateCampaignsControl = styled.div<{ theme: Theme }>`
  display: flex;
  justify-content: space-between;
  position: relative;
  :after {
    content: "";
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.gray.a40};
  }
`;

export const TabViewWrapper = styled.div`
  display: flex;
  flex: 2 1;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 16px;
  ${mediaQueries.lg} {
    flex-direction: column-reverse;
  }
`;
